import Vue from 'vue'
import vant from 'vant'
import App from './App.vue'
import { Picker } from 'vant';
import { Card } from 'vant';
import 'vant/lib/index.css';
import VueAxios from 'vue-axios'
import axios from 'axios'
import router from './router/index.js'
import { Toast } from 'vant'


Vue.config.productionTip = false
Vue.use(vant)
Vue.use(Toast)
Vue.use(Picker)
Vue.use(Card)
Vue.use(VueAxios, axios)

import { Search } from 'vant';
Vue.use(Search);
import {Button} from 'vant'
Vue.use(Button)
import { Image } from 'vant';
Vue.use(Image);
import { Area } from 'vant';
Vue.use(Area);
import { AddressList } from 'vant';
Vue.use(AddressList);
import { IndexBar, IndexAnchor } from 'vant';
Vue.use(IndexBar);
Vue.use(IndexAnchor);
import { List } from 'vant';
Vue.use(List);
import { Icon } from 'vant';
Vue.use(Icon);
import { Cell, CellGroup } from 'vant';
Vue.use(Cell);
Vue.use(CellGroup);
import { Rate } from 'vant';
Vue.use(Rate);

import global from './components/global.vue'
Vue.prototype.global = global


var myTitle = "Service"
var common = {
	usericon:"",
	curorderid:""
}

var svcHome = new Vue({
	router,
	data: function(){
	        return {
	            myTitle,
				common
	        }
	    },		
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {		
		  if (to.meta.title) {
		    document.title = to.meta.title
		  }
		  const type = to.meta.type
		  // 判断该路由是否需要登录权限
		  if (type == 'login') {
		    if (localStorage['isLogin'] ==  "1" ) {
		      next()
		    } else {	
		      next('/login')
		    }
		  } else {
		    next()  // 确保一定要有next()被调用
		  }
	})